import React from "react";
import "./util/dependencies";
import './app.css'

import Router from './router/index';
import { AuthProvider } from "./hooks/useAuth";
import { css } from '@emotion/core';

const App = () => (
  <>
    <AuthProvider>
      <Router />
    </AuthProvider>
  </>
)

export default App
